/** Shared shell classes for pill-shaped labels (Badge, StatusBadge). Colour
 * classes stay local to each component — they differ enough (light fill vs.
 * solid fill) that sharing them would just be an extra layer of lookup. */
export const PILL_SHELL =
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium';
